import { GET_SEMINAR_SPECIFICS, GET_SEMINAR } from '../constants';

const parseSeminars = seminars =>
  seminars.reduce(
    (acc, seminar) => ({
      ...acc,
      [seminar.entryId]: {
        ...acc[seminar.entryId],
        ...seminar,
        seminarType: seminar.seminarType.slug,
      },
    }),
    {}
  );

export default (state = {}, action) => {
  switch (action.type) {
    case `${GET_SEMINAR_SPECIFICS}_PENDING`:
      return state;

    case `${GET_SEMINAR_SPECIFICS}_FULFILLED`: {
      const data = action.payload;

      return {
        ...state,
        ...parseSeminars(data),
      };
    }

    case `${GET_SEMINAR}_FULFILLED`: {
      const data = action.payload;
      const recommendedSeminars = data.reduce((arr, specific) => {
        if (specific.seminarType.recommendedSeminars) {
          return arr.concat(specific.seminarType.recommendedSeminars);
        }
        return arr;
      }, []);
      return {
        ...state,
        ...parseSeminars(data),
        ...parseSeminars(recommendedSeminars),
      };
    }

    case `${GET_SEMINAR_SPECIFICS}_REJECTED`:
      return state;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/seminarSpecifics.js